// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".money-input[data-v-693cd088] {\n  max-width: 6.5em;\n}\n.gst-input[data-v-693cd088] {\n  max-width: 4.5em;\n}\n.quantity-input[data-v-693cd088] {\n  max-width: 3.5em;\n}\n.partno-input[data-v-693cd088] {\n  width: 8em;\n}\n.account-input[data-v-693cd088] {\n  width: 18em;\n}\n.no-border th[data-v-693cd088] {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
